(ns hypnos.consumer.panels.consult.sleep-motion
  "The consult sleep motion step."
  (:require [hypnos.i18n :refer [tr]]
            [re-frame.core :as rf]))

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;; fields

(defn- navigation
  [state nav-fn]
  [:div.field.is-grouped
   [:p.control
    [:button.button.is-rounded.is-info
     {:on-click (fn [_] (nav-fn state :sleep-motion :next))}
     (tr :ui.label/next)]]
   [:p.control
    [:button.button.is-rounded.is-light
     {:on-click (fn [_] (nav-fn state :sleep-motion :prev))}
     (tr :ui.label/prev)]]])

(defn- statement
  [consult]
  [:article.message.is-info
   [:div.message-body
    [:p (tr :ui.survey.sleep-motion/statement (:consult/service-type consult))]]])

(defn sleep-motion-field
  [state]
  [:div.field.has-check ;; .is-horizontal
   [:div.field-label.is-normal
    [:label.label (str (tr :ui.survey.sleep-motion/question))]]
   [:div.field-body
    [:div.field ;; .is-grouped-multiline.is-grouped
     [:div.control
      [:label.b-radio.radio
       [:input.input {:type      :radio
                      :name      "sleep-motion"
                      :checked   (true? (get-in @state [:consult :consult/sleep-motion? :value]))
                      :on-change (fn [e]
                                   (let [old-value (get-in @state [:consult :consult/sleep-motion? :value])
                                         new-value (when (-> e .-target .-checked) true)
                                         changed?  (or (get-in @state [:consult :consult/sleep-motion? :dirty?])
                                                       (not= new-value old-value))]
                                     (swap! state assoc-in
                                            [:consult :consult/sleep-motion? :value]
                                            new-value)
                                     (swap! state assoc-in
                                            [:consult :consult/sleep-motion? :dirty?]
                                            changed?)))
                      :on-focus  (fn [_] (swap! state assoc-in
                                                [:consult :consult/sleep-motion? :touched?]
                                                true))}]
       [:span.check.is-info]
       [:span.control-label (tr :ui.label/yes)]]]
     [:div.control
      [:label.b-radio.radio
       [:input.input {:type      :radio
                      :name      "sleep-motion"
                      :value     (false? (get-in @state [:consult :consult/sleep-motion? :value]))
                      :on-change (fn [e]
                                   (let [old-value (get-in @state [:consult :consult/sleep-motion? :value])
                                         new-value (when (-> e .-target .-checked) false)
                                         changed?  (or (get-in @state [:consult :consult/sleep-motion? :dirty?])
                                                       (not= new-value old-value))]
                                     (swap! state assoc-in
                                            [:consult :consult/sleep-motion? :value]
                                            new-value)
                                     (swap! state assoc-in
                                            [:consult :consult/sleep-motion? :dirty?]
                                            changed?)))
                      :on-focus  (fn [_] (swap! state assoc-in
                                                [:consult :consult/sleep-motion? :touched?]
                                                true))}]
       [:span.check.is-info]
       [:span.control-label (tr :ui.label/no)]]]]]])

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;; step

(defn step
  "The sleep motion step"
  [state nav-fn]
  (let [consult (rf/subscribe [:consumer/consult])]
    [:div.card-content
     ;; statement
     [statement @consult]
     ;; field
     [sleep-motion-field state]
     [:hr]
     ;; navigation
     [navigation state nav-fn]]))
